import { UserRoleEnum, AccountTypeEnum } from 'api/enums';
import { v4 as uuidv4 } from 'uuid';
import { getProxyUrl } from 'config/api-url';

export const getUserRoleLabel = (role: UserRoleEnum) => {
    const map = {
        ADMIN: 'Admin',
        EDITOR: 'Editor',
        VIEWER: 'Viewer',
    };

    return map[role];
};

export const getUserTypeLabel = (type: AccountTypeEnum) => {
    const map = {
        DEFAULT: 'Default',
        GUEST: 'Guest',
    };

    return map[type];
};

export const getInitials = (name: string) => {
    return name[0].toUpperCase();
};

export const generateUniqueId = () => {
    return uuidv4();
};

export const generateProxyUrl = (url: string) => {
    if (!url) return;

    return `${getProxyUrl()}?url=${encodeURIComponent(url)}`;
};
